import * as React from 'react';

import { cn } from '@/lib/core';
import { Icon } from './icon';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  rightIcon?: React.ReactNode;
}

function Input({ className, error, rightIcon, ...props }: InputProps) {
  const hasRightContent = error || rightIcon;

  return (
    <div className="relative flex w-full items-center">
      <input
        data-slot="input"
        aria-invalid={error ? 'true' : undefined}
        className={cn(
          'bg-jncquoi-neutral-00 flex h-10 w-full rounded-none',
          'border-jncquoi-neutral-200 border-[0.5px] border-solid',
          'px-3.75 py-3',
          'font-pp-neue-montreal text-jncquoi-neutral-1000 text-[14px] leading-none tracking-[0.5px]',
          'placeholder:text-jncquoi-neutral-600',
          'focus-visible:border-jncquoi-neutral-1000 focus-visible:outline-none',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'aria-invalid:border-jncquoi-asia-7427c-500',
          'transition-colors',
          hasRightContent && (error && rightIcon ? 'pr-16' : 'pr-10'),
          className
        )}
        {...props}
      />
      {hasRightContent && (
        <div className="absolute right-3.75 flex items-center gap-1.5">
          {error && (
            <Icon
              name="warning-circle"
              width={20}
              height={20}
              className="text-jncquoi-asia-7427c-500 pointer-events-none shrink-0"
            />
          )}
          {rightIcon}
        </div>
      )}
    </div>
  );
}

export { Input };
